<template>
  <v-app-bar
    app
    elevation="4"
    color="black"
    class="header-nav"
  >
    <v-container class="d-flex align-center">
      <!-- 로고 -->
      <router-link to="/" class="text-decoration-none">
        <div class="d-flex align-center">
          <v-avatar
            color="primary"
            size="32"
            size-sm="40"
            class="me-2 me-sm-3"
          >
            <v-icon color="white" size="18" size-sm="24">mdi-code-braces</v-icon>
          </v-avatar>
          <h1 class="text-body-1 text-sm-h6 font-weight-bold text-white mb-0 d-none d-sm-block logo-text">
            Yuniq Coding
          </h1>
          <h1 class="text-body-1 font-weight-bold text-white mb-0 d-block d-sm-none logo-text">
            Yuniq
          </h1>
        </div>
      </router-link>

      <v-spacer></v-spacer>

      <!-- 데스크톱 네비게이션 -->
      <div class="d-none d-md-flex align-center">
        <v-btn
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          variant="text"
          class="mx-1 mx-sm-2 desktop-nav-btn"
          :class="{ 'active-tab': isActiveRoute(item.path) }"
          color="white"
          :prepend-icon="item.icon"
          size="small"
          size-sm="default"
        >
          <span class="d-none d-lg-block">{{ item.label }}</span>
        </v-btn>

        <!-- 로그인 버튼 -->
        <v-btn
          @click="showLogin"
          variant="elevated"
          color="primary"
          class="ms-2"
          prepend-icon="mdi-login"
          size="small"
          size-sm="default"
        >
          <span class="d-none d-lg-block">로그인</span>
        </v-btn>
      </div>

      <!-- 모바일 메뉴 버튼 -->
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="d-md-none"
        color="white"
        size="small"
        size-sm="default"
      ></v-app-bar-nav-icon>
    </v-container>

         <!-- 모바일 사이드바 -->
     <v-navigation-drawer
       v-model="drawer"
       location="right"
       temporary
       width="280"
       color="black"
       class="mobile-drawer"
       :height="'100vh'"
       :max-height="'100vh'"
       overlay-color="rgba(0, 0, 0, 0.7)"
       scrim="false"
     >
       <div class="drawer-header pa-6">
         <h3 class="text-h5 font-weight-bold text-white mb-2">메뉴</h3>
         <p class="text-body-2 text-gray-dark">Yuniq Coding</p>
       </div>
       
       <v-list color="black" class="drawer-list">
         <v-list-item
           v-for="item in navItems"
           :key="item.path"
           :to="item.path"
           @click="drawer = false"
           :prepend-icon="item.icon"
           :title="item.label"
           class="py-4 drawer-item mb-2 nav-item"
           :class="{ 'active-mobile-tab': isActiveRoute(item.path) }"
           color="white"
           rounded="lg"
         ></v-list-item>

         <!-- 모바일 로그인 버튼 -->
         <v-list-item
           @click="showLogin(); drawer = false"
           prepend-icon="mdi-login"
           title="로그인"
           class="py-4 drawer-item mb-2 nav-item mt-4"
           color="primary"
           rounded="lg"
         ></v-list-item>
       </v-list>
     </v-navigation-drawer>
  </v-app-bar>

  <!-- 로그인/회원가입 모달 -->
  <LoginModal
    v-model="loginModalOpen"
    @switch-to-signup="switchToSignup"
  />
  <SignupModal
    v-model="signupModalOpen"
    @switch-to-login="switchToLogin"
  />
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import LoginModal from '@/components/auth/LoginModal.vue'
import SignupModal from '@/components/auth/SignupModal.vue'

const drawer = ref(false)
const route = useRoute()
const loginModalOpen = ref(false)
const signupModalOpen = ref(false)

const navItems = [
  { path: '/', label: '홈', icon: 'mdi-home' },
  { path: '/about', label: '강사 소개', icon: 'mdi-account-tie' },
  { path: '/schedule', label: '내 스케줄표', icon: 'mdi-calendar' },
  { path: '/apply', label: '강의 신청', icon: 'mdi-application' }
]

const isActiveRoute = (path) => {
  console.log('isActiveRoute called with path:', path)
  console.log('Current route.path:', route.path)
  console.log('Current route.name:', route.name)

  if (path === '/') {
    const isHome = route.path === '/'
    console.log('Is home route:', isHome)
    return isHome
  }

  const isActive = route.path.startsWith(path)
  console.log('Is active route:', isActive)
  return isActive
}

const showLogin = () => {
  loginModalOpen.value = true
}

const switchToSignup = () => {
  loginModalOpen.value = false
  signupModalOpen.value = true
}

const switchToLogin = () => {
  signupModalOpen.value = false
  loginModalOpen.value = true
}
</script>

<style scoped>
.header-nav {
  border-bottom: 1px solid var(--mocha-mousse);
  background: linear-gradient(90deg, var(--black-primary) 0%, var(--black-secondary) 100%);
  min-height: 64px !important;
  height: 64px !important;
  display: flex;
  align-items: center;
}

.v-container {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

.mobile-drawer {
  border-left: 2px solid var(--mocha-mousse);
  height: 100vh !important;
  max-height: 100vh !important;
  overflow-y: auto;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-drawer.v-navigation-drawer--temporary {
  transform: translateX(0);
}

.mobile-drawer.v-navigation-drawer--temporary.v-navigation-drawer--closed {
  transform: translateX(100%);
}

.drawer-header {
  border-bottom: 1px solid var(--gray-light);
  background: var(--black-secondary);
  flex-shrink: 0;
}

.drawer-list {
  padding: 1rem;
  flex: 1;
  overflow-y: auto;
}

.drawer-item {
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
}

.drawer-item:hover {
  background: var(--mocha-mousse) !important;
  transform: translateX(-4px);
}

.logo-text {
  font-family: var(--font-professional);
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(164, 120, 100, 0.3);
}

.v-btn--variant-text:hover {
  background-color: rgba(164, 120, 100, 0.2);
  color: var(--mocha-mousse);
}

.nav-item {
  font-size: 1.3rem !important;
  font-weight: 600 !important;
}

.nav-item .v-list-item-title {
  font-size: 1.3rem !important;
  font-weight: 600 !important;
}

.nav-item .v-icon {
  font-size: 1.5rem !important;
}

.desktop-nav-btn {
  font-size: var(--text-sm) !important;
  font-weight: var(--font-medium) !important;
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
  padding: 0 12px !important;
  margin: 0 2px !important;
}

.desktop-nav-btn .v-btn__content {
  font-size: var(--text-sm) !important;
  font-weight: var(--font-medium) !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.desktop-nav-btn .v-icon {
  font-size: var(--text-lg) !important;
  margin-right: 6px !important;
}

/* 활성화된 탭 스타일 */
.active-tab {
  background: var(--mocha-mousse) !important;
  color: var(--black-primary) !important;
  border-radius: 8px !important;
  position: relative;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(164, 120, 100, 0.4) !important;
  font-weight: var(--font-semibold) !important;
  border: 2px solid var(--mocha-mousse) !important;
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
  padding: 0 12px !important;
  margin: 0 2px !important;
  overflow: hidden !important;
}

.active-tab::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--mocha-mousse) !important;
  z-index: -1;
  border-radius: 6px;
}

.active-tab::before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 3px;
  background: var(--mocha-mousse);
  border-radius: 2px;
}

.active-tab:hover {
  background: var(--mocha-mousse) !important;
  color: var(--black-primary) !important;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 16px rgba(164, 120, 100, 0.6) !important;
}

.active-tab .v-icon {
  color: var(--black-primary) !important;
}

.active-tab .v-btn__content {
  color: var(--black-primary) !important;
}

.active-tab .v-btn__prepend {
  color: var(--black-primary) !important;
}

.active-tab .v-btn__append {
  color: var(--black-primary) !important;
}

.active-tab .v-btn__overlay {
  background: transparent !important;
}

.active-tab .v-btn__underlay {
  background: transparent !important;
}

.active-tab .v-btn__loader {
  color: var(--black-primary) !important;
}

.active-mobile-tab {
  background: var(--mocha-mousse) !important;
  color: var(--black-primary) !important;
  border-radius: 12px !important;
  transform: translateX(-4px);
  box-shadow: 0 4px 12px rgba(164, 120, 100, 0.4) !important;
  border: 2px solid var(--mocha-mousse) !important;
}

.active-mobile-tab .v-list-item-title {
  color: var(--black-primary) !important;
  font-weight: bold !important;
}

.active-mobile-tab .v-icon {
  color: var(--black-primary) !important;
}

/* 반응형 디자인 */
@media (max-width: 600px) {
  .header-nav {
    min-height: 56px !important;
    height: 56px !important;
    padding: 0 0.5rem;
  }

  .v-container {
    padding: 0 0.5rem;
  }

  .nav-item {
    font-size: var(--text-base) !important;
  }

  .nav-item .v-list-item-title {
    font-size: var(--text-base) !important;
  }

  .nav-item .v-icon {
    font-size: var(--text-lg) !important;
  }
}

@media (max-width: 960px) {
  .desktop-nav-btn {
    font-size: var(--text-xs) !important;
    padding: 0 8px !important;
  }

  .desktop-nav-btn .v-btn__content {
    font-size: var(--text-xs) !important;
  }

  .desktop-nav-btn .v-icon {
    font-size: var(--text-base) !important;
  }
}
</style>
